module.exports = __webpack_public_path__ + "media/stylesheets/images/mattrz_lp/icon_arrow-2ef55bec4e9ba01a4058ae2a47b5fb14.svg";